import React, { useEffect, useState } from "react";
import { CLOSE_DIALOGUE } from "../../store/dialogue/dialogue.type";
import { useDispatch, useSelector } from "react-redux";
import Button from "../../extra/Button";

function UserMonetization() {
  const dispatch = useDispatch();
  const { dialogueData } = useSelector((state) => state.dialogue);
  const [state, setState] = useState({
    minWatchTime: 0,
    minSubScriber: 0,
    totalWithdrawableAmount: 0,
    totalSubscribers: 0,
    totalViewCount: 0,
    totalWatchTime: 0,
    isMonetization: 0,
  });

  const handleClose = () => {
    dispatch({
      type: CLOSE_DIALOGUE,
      payload: {
        dialogue: false,
      },
    });

    let dialogueData_ = {
      dialogue: false,
    };
    localStorage.setItem("dialogueData", JSON.stringify(dialogueData_));
  };

  useEffect(() => {
    if (dialogueData) {
      setState(dialogueData);
    }
  }, [dialogueData]);

  return (
    <>
      <div
        className="row search-action"
        style={{
          paddingRight: "3px",
          width: "100%",
          display: "flex",
          justifyContent: "center",
          padding: "16px",
          border: "1px solid rgba(128, 128, 128, 0.4)",
          borderRadius: "20px",
        }}
      >
        <div>
          <Button
            btnName={"Back"}
            newClass={"back-btn"}
            onClick={handleClose}
          />
          <h5>Monetization Details of user</h5>
          <div
            style={{
              paddingRight: "3px",
              width: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              padding: "16px",
              borderRadius: "20px",
            }}
          >
            <div
              style={{
                paddingRight: "3px",
                width: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                padding: "16px",
                border: "1px solid rgba(128, 128, 128, 0.4)",
                borderRadius: "20px",
                margin: "20px",
              }}
            >
              <p
                style={{
                  color: "#ff4d67",
                }}
              >
                Min Watch Time Required: {state.minWatchTime}
              </p>
              <p>Total Watch Time: {state.totalWatchTime}</p>
              <p
                style={{
                  color: "#ff4d67",
                }}
              >
                Min Subscriber: {state.minSubScriber}
              </p>
              <p>Total Subscribers: {state.totalSubscribers}</p>
            </div>
            <div
              style={{
                paddingRight: "3px",
                width: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                padding: "16px",
                border: "1px solid rgba(128, 128, 128, 0.4)",
                borderRadius: "20px",
                margin: "20px",
              }}
            >
              <p>Total Withdrawable Amount: {state.totalWithdrawableAmount}</p>
              <p>Total View Count: {state.totalViewCount}</p>
              <p>Is Monetization: {state.isMonetization}</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default UserMonetization;
